/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { REGEX_ACCOUNT, REGEX_BIN } from "../../util/RegEx";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Checkbox, FormControlLabel } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const AfbSpace = (props) => {
  const history = useHistory();
	const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [form, setForm] = useState({ name: "", description: "", cc: "", account_number: "", is_collateral_account: false });
  const [error, setErrors] = useState({ name: false, description: false, cc: false, account_number: false });
  
	useEffect(() => {
    init();
  }, []);

  const init = () => {
    let d = { name: "", description: "", cc: "EMPRESAS", account_number: "", is_collateral_account: false }

    if (props.data.origin.appUUID === "3") {
      d = { name: "", description: "", cc: "INTELIGENCIA_FI", account_number: "", is_collateral_account: false };
    }
    !hasAction("autoClabe") && (d["clabe"] = "");
    setForm(JSON.parse(JSON.stringify(d)));
  };

  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  const createSpace = async () => {
    props.changeLoader(true);
		setZPos(-1)

    let data = {
      data: {
        space: {
          owner: {
            application_uuid: props.data.origin.appUUID,
            entity_uuid: props.data.uuid,
          },
          general: form,
          type: "1",
          profile: "key-debit-n7",
        },
        customer_level: hasAction("customerOrigin") ? props.data.origin.level || "key-debit-n7" :  "key-debit-n7",
      },
    };

    if (form.is_collateral_account) {
      data.data.space["is_collateral_account"] = form.is_collateral_account;
    }

    let createAfbSpace = await API.service( "createAfbSpace", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (createAfbSpace.status == 200) {
      if (createAfbSpace.data.data.response == "OK") {
        if (hasAction("customerOrigin")) {
          let upgradeLevel = await levelUpgrade(createAfbSpace.data.data.data.space.uuid, props.data.origin.level || props.data.origin.subproduct);
          if (upgradeLevel) {
            props.changeAlert(true, "success", "Space creado con éxito");
            closelightbox();
          }
        } else {
          props.changeAlert(true, "success", "Space creado con éxito");
          closelightbox();
        }
      } else if (createAfbSpace.data.data.code == "0005.001.012") {
      } else {
        props.changeAlert(true, "error", "Error al crear el Space");
      }
    }
    props.changeLoader(false);
		setZPos(45)
  };

  const levelUpgrade = async (uuid, key) => {
    props.changeLoader(true);
    let data = {
      entity: {
        uuid: uuid,
        type: "space_account"
      },
      new_space_level : {
        profile : key,
        type : "1"
      }
    };
    

    let request = await API.service('spaceLevelUpgrade', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      return true
    }
    props.changeLoader(false);
  }

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    if (field === "is_collateral_account") {
      f[field] = e.target.checked;
    } else if (field === "clabe" || field === "account_number") {
      if (!isNaN(e.target.value)) {
        f[field] = e.target.value;
      }
    } else {
      f[field] = e.target.value;
    }
    setForm(JSON.parse(JSON.stringify(f)));
    if ( field == "name" || field == "description" || field == "clabe" || field == "cc" || field == "account_number" ) {
      if (!f[field]) {
        er[field] = true;
      } else {
        er[field] = false;
      }

      if (props.data.origin.appUUID === "3") {
        if (f["clabe"] && field == "clabe") {
          if (REGEX_BIN.test(e.target.value)) {
            er["clabe"] = false;
          } else {
            er["clabe"] = true;
          }
        }
        if (f["account_number"] && field == "account_number") {
          if (REGEX_ACCOUNT.test(e.target.value)) {
            er["account_number"] = false;
          } else {
            er["account_number"] = true;
          }
        }
      }
    }
    setErrors(JSON.parse(JSON.stringify(er)));
    if (props.data.origin.appUUID === "3") {
      if ( f["name"] && f["description"] && (!hasAction("autoClabe") ? f["clabe"] : true ) && f["cc"] && f["account_number"] && !er["description"] && !er["name"] && !er["cc"] && !er["account_number"] && (!hasAction("autoClabe") ? !er["clabe"] : true )) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      if ( f["name"] && f["description"] && f["cc"] && f["account_number"] && !er["description"] && !er["name"] && !er["cc"] && !er["account_number"]) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle>
					Crear nuevo space para la cuenta
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<DialogContent>
					<Grid item xs={12}>
						{`${props.data.gname} - ${props.data.lname}`}        
					</Grid>
				</DialogContent>
				
				<DialogContent style={{overflowY: "hidden"}}>
					<Grid container spacing={2} >
						<Grid item xs={6}>
              <TextField
                label="Nombre del Space" value={form.name} onChange={changeValue.bind(this, "name")} size="small" fullWidth error={error.name} helperText={error.name ? 'Dato obligatorio' : ''}/>
            </Grid>
						<Grid item xs={6}>
              <TextField
                label="Descripción del Space" value={form.description} onChange={changeValue.bind(this, "description")} size="small" fullWidth error={error.description} helperText={error.description ? 'Dato obligatorio' : ''}/>
            </Grid>
            {props.data.origin.appUUID === "3" && !hasAction("autoClabe") && 
							<Grid item xs={6}>
								<TextField
									label="Clabe Interbancaria" value={form["clabe"]} onChange={changeValue.bind(this, "clabe")} size="small" fullWidth error={error["clabe"]} helperText={error["clabe"] ? 'Debe tener una longitud de 18 dígitos y comenzar con un BIN de albo' : ''}/>
							</Grid>
						}
						{props.data.origin.appUUID === "3" && 
							<Grid item xs={6}>
								<TextField
									label="Centro de Costos" value={form.cc} onChange={changeValue.bind(this, "cc")} size="small" fullWidth error={error.cc} helperText={error.cc ? 'Dato obligatorio' : ''}/>
							</Grid>
						}
						<Grid item xs={6}>
              <TextField
                label="Número de Cuenta" value={form.account_number} onChange={changeValue.bind(this, "account_number")} size="small" fullWidth error={error.account_number} helperText={error.account_number ? 'Debe tener una longitud máxima de 20 dígitos y solo contener números' : ''} inputProps={{ maxLength: 20}} />
            </Grid>
					</Grid>
          <Grid item xs={6} style={{marginTop: "10px"}}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.is_collateral_account}
                  onChange={changeValue.bind(this, "is_collateral_account")}
                  name="is_collateral_account"
                  color="primary"
                />
              }
              label="Cuenta colateral"
            />
            </Grid>
				</DialogContent>

				<DialogActions>
					<Button disabled={disabled} variant="contained" onClick={createSpace.bind(this)} >Crear Space</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog> 
  );
};

export default AfbSpace;
